import React from 'react';

/**
 * 地图加载中 / 地球自转提示浮层
 */
export default function DashboardMapLoadingOverlay({
  mapLoadingState,
  mapReady,
  isEarthAnimationActive
}) {
  return (
    <>
      {mapLoadingState === 'loading' && !mapReady && (
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1000,
          background: 'rgba(255, 255, 255, 0.9)',
          padding: '20px 30px',
          borderRadius: '10px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
          textAlign: 'center',
          fontFamily: 'Arial, sans-serif'
        }}>
          <div style={{
            fontSize: '18px',
            color: '#1976d2',
            marginBottom: '10px',
            fontWeight: 'bold'
          }}>
            🌍 正在加载地球视图...
          </div>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #1976d2',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto'
          }} />
          <div style={{
            fontSize: '14px',
            color: '#666',
            marginTop: '10px'
          }}>
            请稍候，正在预加载地图瓦片
          </div>
        </div>
      )}

      {mapLoadingState === 'loaded' && isEarthAnimationActive && (
        <div style={{
          position: 'absolute',
          top: '20px',
          left: '20px',
          zIndex: 1000,
          background: 'rgba(25, 118, 210, 0.9)',
          color: 'white',
          padding: '8px 16px',
          borderRadius: '20px',
          fontSize: '14px',
          fontWeight: 'bold',
          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
          animation: 'pulse 2s infinite'
        }}>
          🌍 地球正在自转中... 点击任意位置飞到上次设备定位
        </div>
      )}
    </>
  );
}
